import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeAdmin always passes the selected office (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class OfficeVideoCostsEditItem {}

export default class EditOfficeVideoWindowDescription {
  static titleForEdit = (item) => `Edit Video Costs Information (${item.Name})`;
  static itemType = OfficeVideoCostsEditItem;
  static finishButtonLabel = 'Save Office';
  static messageOnSuccess = 'Office has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited office object is posted back
  // (OfficeService.EditOffice string-converts and PUTs the entire office). MUST return the
  // promise (wizard contract).
  static serviceFunction = (edited) => OfficeService.EditOffice(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ShippingCostPerEval',
          label: 'Shipping Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CaseCostPerEval',
          label: 'Case Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'EditorCostPerHour',
          label: 'Editor Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CardCostPerEval',
          label: 'Card Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CaseCostPerEval1',
          label: 'Single Case Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'TimeCaptureCostPerHour',
          label: 'Time Capture Cost / Hour',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CdrcostPerEval',
          label: 'Cdr Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CaseCostPerEval2',
          label: 'Double Case Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'StreamingCostPerHour',
          label: 'Streaming Cost/Hour',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'DvdcostPerEval',
          label: 'DVD Cost',
          className: 'col-4',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Dnepct',
          label: 'DNE %',
          className: 'col-8',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
